import React from "react";
import PropTypes from "prop-types";
import styles from "./ImageSectionElement.module.css";
import DefaultImage from "../../assests/home-feed-image-coming-soon.jpg";
import classNames from "classnames";

/**
 * View component. Displays a feed item section’s image.
 */
export function ImageSectionElement({ currentPhoto }) {
  return (
    <div
      className={classNames(styles.container, {
        [styles.alignRight]: currentPhoto.align === "right",
        [styles.alignLeft]: currentPhoto.align === "left",
      })}
    >
      {currentPhoto.link === "" ? (
        <img
          src={currentPhoto.src ? currentPhoto.src : DefaultImage}
          alt=""
          className={styles.imgDefault}
        />
      ) : (
        <a target="_blank" rel="noreferrer" href={currentPhoto.link}>
          <img
            src={currentPhoto.src ? currentPhoto.src : DefaultImage}
            alt=""
            className={styles.imgDefault}
          />
        </a>
      )}

      {/* {currentPhoto.src === "" ? (
        <div>
          <img src={DefaultImage} alt="" />
        </div>
      ) : (
        <div>
          <img src={currentPhoto.src} alt="" />
        </div>
      )} */}
    </div>
  );
}

ImageSectionElement.propTypes = {
  /**
   * Object containing the selected photo’s src and set alignment
   * with an optional clickable link.
   */
  currentPhoto: PropTypes.shape({
    src: PropTypes.string,
    align: PropTypes.oneOf(["left", "center", "right"]),
    link: PropTypes.string,
  }),
};

ImageSectionElement.defaultProps = {
  currentPhoto: {
    src: DefaultImage,
  },
};
